const items = [
    "11 Years of Trust",
    "Quick Response",
    "Good Value",
    "Helpful Staff",
    "Open 24 Hours",
    "Car Rental & Outstation Cabs",
];

const Marquee = () => {
    const doubled = [...items, ...items];
    return (
        <div className="relative overflow-hidden border-y border-[#E5E7EB] bg-[#1B3B2B] py-4 text-[#FAFAF5]">
            <div className="marquee-track flex w-max whitespace-nowrap gap-10">
                {doubled.map((t, i) => (
                    <span
                        key={i}
                        className="font-display text-lg md:text-2xl italic opacity-90"
                    >
                        {t}
                        <span className="mx-6 text-[#C46A42]">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
